export const formatMoney = (value: number, locale: string): string =>
	value.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
